<template>
    <div class="zy-json-forms" ref="form" :model="form">

        <json-forms ref="jsonFormEl" v-bind:data="schemaData" v-bind:renderers="renderers" v-bind:schema="schema"
            v-bind:uischema="uischema" :i18n="{ locale: 'zh-cn', translate: translation }" @change="onChange"
            :validationMode="validationMode" :readonly="readonly" />

        <slot name="options">
        </slot>
    </div>
</template>
  
<script>
import { defineComponent } from "vue";
import { JsonForms } from "@jsonforms/vue2";
/*自定义render*/
import ZyRenders from "./renders/render.js";
/*defaultStyles:默认样式,mergeStyles:样式合并,vanillaRenderers:默认render*/
import {
    defaultStyles,
    mergeStyles,
} from '@jsonforms/vue2-vuetify';
import { vuetifyRenderers } from '@jsonforms/vue2-vuetify';
/*语言包转换*/
import translator from "./config/lang.js";
import { Ajv } from "ajv";
const myStyles = mergeStyles(defaultStyles, { control: { root: 'my-control' } });

const renderers = [
    ...vuetifyRenderers,
    ...ZyRenders
];


export default defineComponent({
    name: "ZyJsonForms",
    components: { JsonForms },
    props: {
        
        readonly: {
            type: Boolean,
            default: false
        },
        validationMode: {
            required: false,
            type: String,
            default:"ValidateAndHide",

        }

    },
    data() {
        return {
            isLoading: true,
            isWorking: false,
            showRst: false,
            renderers: Object.freeze(renderers),
            pbcId: "",
            form: {},
            schemaData: {},
            schema: {},
            uischema: {},
            translation: translator,
        }
    },

    methods: {
        onChange(event) {
            this.form = event.data;
           // this.$emit("change", event.data);
        },
        InitJsonForms(schema, uischema, schemaData) {
            this.schema = schema;
            this.uischema = uischema;
            this.schemaData = schemaData;
        },
        getFomData(){
            return this.form;
        }

    },
    created() {

    },
    provide() {
    }
})
</script>
  
<style lang="less" scoped>

.categorization .row {
    padding: 0 10px;
}

.btnpbcDebug {
    text-align: center;
}

.debugfinish {
    text-align: center;
}



.myjsonforms .v-card__title {
    font-size: .5rem;
    line-height: .6rem;
}

.myjsonforms .v-card__subtitle,
.v-card__text,
.v-card__title {
    padding: 0.2rem;
}


.container {
    padding: 10px;

}



.v-toolbar__content,
.v-toolbar__extension {
    padding: 0;
}

.v-select-list .v-list-item__title {
    font-size: .4rem;

}

.v-item-group.v-bottom-navigation {
    justify-content: space-around;
    ;
}

.v-item-group {
    padding-top: 0 !important;
}

.btn-action {
    width: 100%;
}

.v-label,
.v-input {
    font-size: 12px;
}


.row+.row {
    margin-top: 0;
}




.v-list-item__title {
    font-size: 16px !important;

}

.el-scrollbar {
    /deep/.el-scrollbar__wrap {
        overflow-x: hidden;
    }
}
</style>
  